import { createStreamHook } from '@/service/ws/use-web-socket-with-proto'
import { TreeNewsPost, TreeNewsStream } from '@/types/generated/public_api'

export const useTreeNewsStream = createStreamHook<TreeNewsStream, TreeNewsPost>({
  channelKey: 'treeNewsStream',
  extractResponse: (message) => message.data?.treeNewsPost,
  getPayloadDeps: () => [],
  listenerChannelKey: 'treeNewsStream',
})
